module.exports = __webpack_public_path__ + "img/qyflyz.aeff87d1.png";